export default __webpack_public_path__ + "static/media/misc-closetB-1440w.c7e4fb7f.png";